import { render, staticRenderFns } from "./SmartLabel.vue?vue&type=template&id=7b5d1428&scoped=true&"
import script from "./SmartLabel.vue?vue&type=script&lang=js&"
export * from "./SmartLabel.vue?vue&type=script&lang=js&"
import style0 from "./SmartLabel.vue?vue&type=style&index=0&id=7b5d1428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d1428",
  null
  
)

export default component.exports